import React from "react";
import { Box, Button, Typography, ToggleButtonGroup, ToggleButton } from "@mui/material";
import { GridView, ViewList } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import config from "config";
export const CoursesNavbar = ({ viewMode, setViewMode }) => {
  const navigate = useNavigate();

  const addCourses = () => {
    navigate("/course/new");
  };

  return (
    <Box
      sx={{
        maxWidth: "975px",
        margin: "0px auto 0 auto",
        padding: "20px",
        display: "block",
        width: "100%",
      }}
    >
      {/* Row Container - Title (Left) & Button (Right) */}
      <Box
        sx={{
          display: "inline-flex",
          justifyContent: "space-between",
          alignItems: "center",
          width: "100%",
        }}
      >
        {/* Title (Fully Left-Aligned) */}
        <Typography
          sx={{
            fontSize: "2.5rem",
            color: "#000",
            fontWeight: "bold",
            marginLeft: "0px",
          }}
        >
          Courses
        </Typography>

        {/* View Toggle & Add Course Button */}
        <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
          {/* View Mode Toggle */}
          <ToggleButtonGroup
            value={viewMode}
            exclusive
            onChange={(e, newView) => newView && setViewMode(newView)}
            aria-label="view mode"
            sx={{
              '& .MuiToggleButton-root': {
                border: '1px solid #e0e0e0',
                padding: '8px 12px',
                color: '#666',
                '&.Mui-selected': {
                  backgroundColor: '#e8d5f0',
                  color: '#712d93',
                  borderColor: '#d4b5e0',
                  '&:hover': {
                    backgroundColor: '#dfc7ea',
                  }
                },
                '&:hover': {
                  backgroundColor: '#f5f5f5',
                }
              }
            }}
          >
            <ToggleButton value="grid" aria-label="grid view">
              <GridView />
            </ToggleButton>
            <ToggleButton value="list" aria-label="list view">
              <ViewList />
            </ToggleButton>
          </ToggleButtonGroup>

          {/* Add Course Button (Fully Right-Aligned) */}
          <Button
            onClick={addCourses}
            variant="contained"
            color="primary"
            //className={`btnconfig ${config["class-name"]}`}
            sx={{
              color: "#fff",
              padding: "10px 20px",
              borderRadius: "28px",
            }}
          >
            + Add Course
          </Button>
        </Box>
      </Box>

      {/* Full-Width Divider */}
      <hr
        style={{
          width: "100%",
          borderTop: "1px solid #ccc",
          marginTop: "10px",
        }}
      />
    </Box>
  );
};
